import { Phone } from "lucide-react";
import Reveal from "../components/Reveal";
import { trackPhoneClick } from "../lib/analytics";

const STEPS = [
    {
        n: "01",
        title: "Call Our Team",
        body: "A short, direct conversation about your hiring goals, your timeline, and the markets you are considering.",
    },
    {
        n: "02",
        title: "Review Your Options",
        body: "We outline suitable EOR and employment administration arrangements for your situation, with honest guidance on what is and is not supported.",
    },
    {
        n: "03",
        title: "Agree & Set Up",
        body: "Once you decide to proceed, service terms are agreed in a written agreement and employment administration is prepared for your market.",
    },
    {
        n: "04",
        title: "Onboard & Manage",
        body: "Your team members are onboarded with proper documentation, and ongoing workforce administration is handled for the life of the engagement.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            data-testid="how-it-works-section"
            className="grain relative overflow-hidden bg-navy py-24 lg:py-32"
        >
            <div className="dot-grid absolute inset-0" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
                <div className="max-w-2xl">
                    <Reveal>
                        <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] text-gold">
                            <span className="h-px w-10 bg-gold/70" aria-hidden="true" />
                            How It Works
                        </p>
                        <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                            A clear path from first call to ongoing support
                        </h2>
                    </Reveal>
                </div>

                <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
                    {STEPS.map((step, i) => (
                        <Reveal key={step.n} delay={i * 0.1} className="h-full">
                            <div
                                data-testid={`how-step-${i}`}
                                className="flex h-full flex-col bg-navy p-8 lg:p-9"
                            >
                                <span className="font-display text-4xl font-extrabold tracking-tight text-gold/90">
                                    {step.n}
                                </span>
                                <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-white">
                                    {step.title}
                                </h3>
                                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/60">
                                    {step.body}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2} className="mt-12">
                    <a
                        href="tel:+18333439367"
                        data-testid="how-it-works-call-cta"
                        onClick={() => trackPhoneClick("how_it_works")}
                        className="inline-flex items-center gap-2.5 rounded-full bg-gold px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wider text-navy transition-[background-color,transform] duration-200 hover:bg-[#b8985a] hover:scale-[1.03]"
                    >
                        <Phone size={16} strokeWidth={2.5} aria-hidden="true" />
                        Start With Step One — Call Us
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
